import React from 'react'
import { QueryClient, QueryClientProvider } from 'react-query'
import { StyledPagesCTAContainer } from './TNCreateAccountCTA.styled'
import { VerifyEmailContent, LoginContent } from './components'
import {
    AppState,
    AuthenticationState,
    SignupOrigin,
    getLoginProvider,
} from '@news-mono/web-common'
import { useSelector } from 'react-redux'
import { SaveNameContent } from './components/SaveNameContent'
import { UserSettingProps } from '../../../user-setting'

export const queryClient = new QueryClient()

export interface PageCtaProps {
    notLoggedInText: CTAText
    emailVerifyText: CTAText
    blockStyle?: 'comments' | 'default'
    userSettings?: UserSettingProps
    componentOrigin?: SignupOrigin
}

export const TNPageCreateAccountCTA: React.FC<PageCtaProps> = (props) => {
    return (
        <QueryClientProvider client={queryClient}>
            <TNPageCreateAccountCTAInternal {...props} />
        </QueryClientProvider>
    )
}

const TNPageCreateAccountCTAInternal: React.FC<PageCtaProps> = ({
    notLoggedInText,
    emailVerifyText,
    blockStyle,
    userSettings,
    componentOrigin,
}) => {
    const {
        isLoggedIn,
        isLoading,
        emailVerified,
        hasUserName,
        wanUserId: auth0Id,
    } = useSelector<AppState, AuthenticationState>(
        (state) => state.authentication,
    )

    const isExternalAuthProvider = getLoginProvider(auth0Id) !== 'Auth0'

    if (isLoading) return null

    if (!isLoggedIn) {
        return (
            <StyledPagesCTAContainer blockStyle={blockStyle}>
                <LoginContent
                    text={notLoggedInText}
                    componentOrigin={componentOrigin}
                />
            </StyledPagesCTAContainer>
        )
    }

    if (!emailVerified) {
        return (
            <StyledPagesCTAContainer blockStyle={blockStyle}>
                <VerifyEmailContent text={emailVerifyText} auth0Id={auth0Id} />
            </StyledPagesCTAContainer>
        )
    }

    if (!hasUserName && userSettings && !isExternalAuthProvider) {
        return (
            <StyledPagesCTAContainer blockStyle={blockStyle}>
                <SaveNameContent auth0Id={auth0Id} {...userSettings} />
            </StyledPagesCTAContainer>
        )
    }

    return null
}
